import { IndeterminateProgressCircle } from '@sunwebgroup/uds-ui/IndeterminateProgressCircle'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import { useIntl } from '@/intl'
import styles from './ParticipantEditShared.module.css'

export function ParticipantEditSavingMessage() {
  const { formatMessage } = useIntl()

  return (
    <div className={styles.loaderContainer} role="status">
      <IndeterminateProgressCircle />
      <Typography className={styles.savingMessage} as="p" variant="body-m-regular-snug">
        {formatMessage({ id: 'booking_details_participant_edit_saving_message' })}
      </Typography>
    </div>
  )
}
